export const JOIN_PROMPT_STORAGE_KEY = "pf_blog_join_prompt";
/** Once shown, don't prompt the same visitor again for this long. */
export const JOIN_PROMPT_SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000;
/** Delay before the prompt appears, so the reader gets value first. */
export const JOIN_PROMPT_DELAY_MS = 7000;

/**
 * Whether the join prompt should be scheduled: true when there is no prior
 * stamp, when the stored stamp is older than the suppression window, or when
 * the stored value is malformed. Pure and dependency-free, so the "show once
 * per 7 days" rule is unit-testable without a DOM.
 */
export function shouldPrompt(storedRaw: string | null, now: number): boolean {
  if (!storedRaw) return true;
  const stamp = Number(storedRaw);
  if (!Number.isFinite(stamp)) return true;
  return now - stamp >= JOIN_PROMPT_SUPPRESS_MS;
}
